import { useTran } from "@/hooks";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

import { Button } from "@/components/ui/button";
import { PATHS } from "@/lib/router";
import ManageUserCard from "../components/ManageUserCard";

const ManageUserPage = () => {
  const { t } = useTran();
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          onClick={() => navigate(PATHS.USER_LIST)}
          className="gap-2"
        >
          <ArrowLeft className="h-4 w-4" />
          {t("Back to user list")}
        </Button>
      </div>

      <ManageUserCard />
    </div>
  );
};

export default ManageUserPage;
